export enum TranscriptionStatus {
  QUEUED = "queued",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed"
}

export interface TranscriptionJob {
  jobId: string;
  status: TranscriptionStatus;
}

export interface Word {
  word: string;
  start: number;
  end: number;
  confidence: number;
  speaker?: number;
  speaker_confidence?: number;
  punctuated_word?: string;
}

export interface Utterance {
  speaker: number;
  transcript: string;
  start: number;
  end: number;
  confidence: number;
  words: Word[];
  id?: string;
}

export interface TranscriptionResult {
  id: string;
  text: string;
  language: string;
  duration: number;
  status: TranscriptionStatus;
  segments?: Word[];
  utterances?: Utterance[];
  createdAt: Date;
}

export interface CreateTranscriptionDto {
  fileId: string;
  language?: string;
}
